import Button from 'antd/es/button';
import Radio from 'antd/es/radio';
import Card from 'antd/es/card';
import Form from 'antd/es/form';
import Select from 'antd/es/select';
import Spin from 'antd/es/spin';
import Input from 'antd/es/input';
import Modal from 'antd/es/modal';
import Table from 'antd/es/table';
import Checkbox from "antd/es/checkbox";
import AutoComplete from 'antd/es/auto-complete';
import React from "react";
import { createDebounce, getFormFieldByTypeForTpwModule, sanitizeFieldName } from "../../util/methods";
import SubListTpw from "../../components/SubListTpw";
import DocumentList from "../../components/DocumentList";
import './invoiceEntry.css'
import SelectActivity from "./SelectActivity";
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (<EditableContext.Provider value={form}>
    <tr {...props} />
</EditableContext.Provider>);
const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
    /*state = {
      editing: false,
    };*/

    /*toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({editing}, () => {
        if (editing) {
          this.input.focus();
        }
      });
    };*/

    save = (e, rec, sno) => {
        const { record, handleSave } = this.props;
        let data = [], recordData = [], spare = false;
        recordData = Object.keys(record);

        for (let i = 0; i < recordData.length; i++) {
            if (recordData[i] === 'spare') {
                spare = true;
            }
        }

        this.form.validateFields((error, values) => {
            let val = values && Object.keys(values);

            for (let k = 0; k < (val && val.length); k++) {
                if (val[k] === rec) {
                    values[rec] = e.target.value;
                }
            }
            data = Object.keys(values);
            for (let j = 0; j < (data && data.length); j++) {
                if (spare && values[data[j]] !== '' && parseFloat(values[data[j]]) % 1 !== 0) {
                    values[data[j]] = parseFloat(values[data[j]]);
                    //message.error('Should be an Integer');
                } else if (spare && values[data[j]] !== '' && parseFloat(values[data[j]]) % 1 === 0) {
                    values[data[j]] = parseInt(values[data[j]]);
                }
            }
            handleSave({ ...record, ...values, sno: sno });
        });
    };

    equallyDistribute = (e, sno) => {
        const { record, handleSave } = this.props;
        let recordData, count = 0, valueKeys = [];
        recordData = Object.keys(record);

        if (e.target.checked) {
            for (let i = 0; i < recordData.length; i++) {
                if (recordData[i] !== 'equal' && recordData[i] !== 'total' && recordData[i] !== 'labour' && recordData[i] !== 'labourCost' && recordData[i] !== 'sno') {
                    count++;
                    valueKeys.push(recordData[i]);
                }
                record['equal'] = true;
            }
        }

        if (e.target.checked && count !== 0) {
            for (let j = 0; j < valueKeys.length; j++) {
                this.form.setFieldsValue({
                    [`${valueKeys[j]}`]: parseFloat(record['labourCost'] / count).toFixed(2), 'equal': true
                });
                record[valueKeys[j]] = parseFloat(record['labourCost'] / count).toFixed(2);
                record['equal'] = true;
            }
        }

        if (!(e.target.checked)) {
            this.form.setFieldsValue({
                'equal': false
            });
            record['equal'] = false;
        }

        this.form.validateFields((error, values) => {
            handleSave({ ...record, ...values, sno: sno });
        });
    }


    renderCell = form => {
        this.form = form;
        const { dataIndex, record, title, formTitle } = this.props;
        let recordData = [], spare = false;
        recordData = Object.keys(record);
        for (let i = 0; i < recordData.length; i++) {
            if (recordData[i] === 'spare') {
                spare = true;
            }
        }

        if (formTitle && formTitle === 'CREATE') {
            if (dataIndex !== 'equal') {
                return (<Form.Item key={spare ? `spare${record.key}0` : `labour${record.key}0`} style={{ margin: 0 }}>
                    {form.getFieldDecorator(dataIndex, {
                        // rules: [{
                        //   required: true,
                        // },],
                        initialValue: spare ? (record && dataIndex && record[dataIndex]) : (record && dataIndex && record[dataIndex] && record[dataIndex] % 1 !== 0) ? parseFloat(record[dataIndex]).toFixed(2) : record[dataIndex],
                    })(<Input size="small" style={{ width: '100%' }} disabled={formTitle === 'EDIT' || record.equal}
                        type='number'
                        ref={node => (this.input = node)} onChange={(e) => {
                            this.save(e, dataIndex, record.sno)
                        }} onPressEnter={this.save} />)}
                </Form.Item>)
            }

            if (dataIndex === 'equal') {
                return (<Form.Item key={spare ? `spare${record.key}1` : `labour${record.key}1`} style={{ margin: 0 }}>
                    {form.getFieldDecorator(dataIndex, {})(<Checkbox size="small" defaultChecked={true}
                        style={{ width: '100%', marginLeft: '25%' }}
                        ref={node => (this.input = node)}
                        onChange={(e) => {
                            this.equallyDistribute(e, record.sno)
                        }} />)}
                </Form.Item>)
            }
        } else {
            if (dataIndex !== 'equal') {
                return (<Form.Item key={spare ? `spare${record.key}2` : `labour${record.key}2`} style={{ margin: 0 }}>
                    {form.getFieldDecorator(dataIndex, {
                        // rules: [{
                        //   required: true, message: `${title} is required.`,
                        // },],
                        initialValue: spare ? (record && dataIndex && record[dataIndex]) : (record && dataIndex && record[dataIndex] && record[dataIndex] % 1 !== 0) ? parseFloat(record[dataIndex]).toFixed(2) : record[dataIndex],
                    })(<Input size="small" style={{ width: '100%' }} disabled={formTitle === 'EDIT'} type='number'
                        ref={node => (this.input = node)} onChange={(e) => {
                            this.save(e, dataIndex, record.sno)
                        }} onPressEnter={this.save} />)}
                </Form.Item>)
            }
            if (dataIndex === 'equal') {
                return (<Form.Item key={spare ? `spare${record.key}3` : `labour${record.key}3`} style={{ margin: 0 }}>
                    {form.getFieldDecorator(dataIndex, {})(<Checkbox size="small" checked={record[dataIndex]}
                        style={{ width: '100%', marginLeft: '25%' }} />)}
                </Form.Item>)
            }
        }
    };

    render() {
        const { editable, dataIndex, title, record, index, handleSave, formTitle, children, ...restProps } = this.props;
        return (<td {...restProps}>
            {editable ? (<EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>) : (children)}
        </td>);
    }
}

class Create extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            documentData: [],
            value: null,
            visible: false,
            invoiceData: [],
            values: {},
            spareData: [],
            labourData: [],
            isModalValidated: true,
            message: '',
            checked: false,
            showEdit: false,
            createdVendors: [],
        };
    }

    mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
        const merged = [...(baseOptions || [])];
        (createdOptions || []).forEach((created) => {
            if (!created || !created._id) {
                return;
            }
            const exists = merged.find((item) => `${item && item._id}` === `${created._id}`);
            if (!exists) {
                merged.push(created);
            }
        });
        return merged;
    };

    getVendorOptions = () => {
        const { filters } = this.props;
        const baseOptions = filters && filters.vendor && filters.vendor.data && filters.vendor.data.data || [];
        return this.mergeUniqueOptions(baseOptions, this.state.createdVendors);
    };

    handleVendorCreated = (createdVendor) => {
        if (!createdVendor || !createdVendor._id) {
            return;
        }
        this.setState((prevState) => {
            const exists = (prevState.createdVendors || []).find((item) => `${item._id}` === `${createdVendor._id}`);
            if (exists) {
                return null;
            }
            return {
                createdVendors: [...(prevState.createdVendors || []), createdVendor],
            };
        });
        this.props.form.setFieldsValue({
            vendor: createdVendor._id,
        });
    };

    handleLabourSave = async (row) => {
        let sum = 0;
        const newData = [...this.state.labourData];
        //const index = await newData.findIndex(item => row.labour === item.labour);
        const index = await newData.findIndex(item => parseInt(row.sno) === parseInt(item.sno));
        const item = newData[index];

        newData.splice(index, 1, {
            ...item, ...row,
        });

        newData && newData[index] && await Object.keys(newData[index]).map(key => {
            if (key !== 'equal' && key !== 'total' && key !== 'labour' && key !== 'labourCost' && key !== 'sno') {
                sum = (sum + parseFloat(newData[index][key]));
            }
        });
        sum = parseFloat(sum).toFixed(2);
        newData[index]['total'] = sum;
        if (sum !== parseFloat(newData[index]['labourCost']).toFixed(2)) {
            this.setState({
                isModalValidated: false,
                message: `Total Cost didn\'t Matched to the Total Amount Planned for Labour - ${row.labour}`
            });
        } else {
            this.setState({ isModalValidated: true })
        }
        this.setState({ labourData: newData });
    };

    handleSave = async (row) => {
        let sum = 0;
        const newData = [...this.state.spareData];
        // const index = await newData.findIndex(item => row.spare === item.spare);
        const index = await newData.findIndex(item => row.sno === item.sno);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item, ...row,
        });

        newData && newData[index] && await Object.keys(newData[index]).map(key => {
            if (key !== 'equal' && key !== 'total' && key !== 'spare' && key !== 'spareUnits' && key !== 'sno') {
                sum = sum + parseFloat(newData[index][key]);
            }
        });

        sum = parseFloat(sum).toFixed(2);
        newData[index]['total'] = sum;
        if (sum !== parseFloat(newData[index]['spareUnits']).toFixed(2)) {
            this.setState({
                isModalValidated: false,
                message: `Total Units didn\'t Matched to the No. of units allotted to the Spare - ${row.spare}`
            });
        } else {
            this.setState({ isModalValidated: true })
        }
        this.setState({ spareData: newData });
    };

    getDocumentData = (data) => {
        this.setState({ documentData: data });
    };

    componentDidMount() {
        const { match, fetch, data } = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
        }
        // if(this.props.title === 'CREATE') {
        //   this.props.fetchActivitySno();
        // }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.tableData && nextProps.tableData && nextProps.tableData.jobCards && nextProps.tableData.jobCards.length && nextProps.tableData.spareNames && JSON.stringify(nextProps.tableData.spareNames) !== JSON.stringify(this.props.tableData.spareNames)) {
            this.setState({ spareData: nextProps.tableData.spareNames });
        }
        if (nextProps.tableData && nextProps.tableData && nextProps.tableData.activities && nextProps.tableData.activities.length && nextProps.tableData.labourNames && JSON.stringify(nextProps.tableData.labourNames) !== JSON.stringify(this.props.tableData.labourNames)) {
            this.setState({ labourData: nextProps.tableData.labourNames });
        }
        if (nextProps.tableData && nextProps.tableData.display && nextProps.tableData.display !== 'notFound' && nextProps.tableData.display !== 'noScreen' && nextProps.tableData.display === 'labour') {
            this.setState({ spareData: [] });
        } else if (nextProps.tableData && nextProps.tableData.display && nextProps.tableData.display === 'notFound' && nextProps.tableData.display !== 'noScreen' && nextProps.tableData.display !== 'labour') {
            this.setState({ spareData: [], labourData: [] });
        } else if (nextProps.tableData && nextProps.tableData.display && nextProps.tableData.display !== 'notFound' && nextProps.tableData.display === 'noScreen' && nextProps.tableData.display !== 'labour') {
            this.setState({ spareData: [], labourData: [] });
        }
    }

    componentWillUnmount() {
        this.props.clearProps();
    }

    handleSubmit = (e) => {
        const { match, quotations, title } = this.props;
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (err) {
                return console.log(err);
            }
            const data = Object.assign({}, values);
            const { documentData } = this.state;
            const { checked } = this.state;
            // data.documents = documentData.length ? documentData : null;

            data.warranty = checked;
            if (documentData.length === 0) {
                data.documents = quotations && quotations.length && quotations[(quotations.length) - 1].documents;
            } else {
                data.documents = documentData;
            }
            if (data && !data.tpwNo) {
                data.tpwNo = null;
            }
            if (data && !data.activityNo) {
                data.activityNo = null;
            }

            if (this.props.title && this.props.title !== 'EDIT') {
                this.props.forModalSubmit(data);
                this.setState({ visible: true, invoiceData: data });
            } else if (this.props.title === 'EDIT') {

                if (match.params && match.params.id) {
                    this.props.onSubmit(data, match.params.id);
                } else {
                    // this.props.onSubmit(data);
                }
            }
        })
    };

    handleModalCancel = () => {
        this.setState({ visible: false });
    }

    handleLabourChecked = async (e, index, record) => {
        let count = 0;
        let data = [...this.state.labourData];
        record && await Object.keys(record).map(key => {
            if (key !== 'equal' && key !== 'total' && key !== 'labour' && key !== 'labourCost') {
                count++;
            }
        });

        if (e.target.checked) {
            if (data && data[index]) {
                data[index].equal = true;
                data[index] && await Object.keys(data[index]).map(key => {
                    if (key !== 'equal' && key !== 'total' && key !== 'labour' && key !== 'labourCost') {
                        data[index][key] = (data[index]['labourCost'] / count);
                    }
                });
                this.setState({ labourData: data });
            }
        }

        if (!(e.target.checked)) {
            if (data && data[index]) {
                data[index].equal = false;
                this.setState({ labourData: data });
            }
        }
    }

    handleOk = () => {
        let create = true;
        let submitData = {
            spareData: this.state.spareData, labourData: this.state.labourData, invoiceData: this.state.invoiceData
        };

        if (this.props && this.props.tableData && this.props.tableData.display !== 'notFound' && this.props.tableData.display !== 'noScreen' && this.props.tableData.display === 'labour') {
        } else {
            if (this.state.spareData && this.state.spareData.length) {
                for (let i = 0; i < this.state.spareData.length; i++) {
                    if (this.state.spareData[i]['total']) {
                        if (this.state.spareData[i]['total'] === 0 || this.state.spareData[i]['total'] === '') {
                            {
                                create = false;
                                this.setState({
                                    isModalValidated: false,
                                    message: 'Total Units Can\'t be Zero or Empty'
                                });
                            }
                        }
                    } else {
                        create = false;
                        this.setState({ isModalValidated: false, message: 'Total Units Can\'t be Zero or Empty' });
                    }
                }
            }
        }

        if (create && this.state.isModalValidated) {
            let spareValue = this.props && this.props.sparesData;
            let labourValue = this.props && this.props.labourData;
            let sumValue = 0;
            spareValue && spareValue.map(item => {
                sumValue = sumValue + item;
            });
            labourValue && labourValue.map(itm => {
                sumValue = sumValue + itm;
            });
            submitData.invoiceData.totalCost = sumValue;
            this.props.onSubmit(submitData);
            this.setState({ visible: false });
        }
    }

    viewCostAllocation = () => {
        this.setState({ visible: true });
    }

    onRadioChange = (e) => {
        console.log('e', e);
        if (e.target.value === 'activityNo') {
            this.props.clearProps();
            this.props.updateValue('activityNo');
        } else {
            this.props.updateValue('tpwNo');
        }
        this.setState({ value: e.target.value });
    }

    onChangeForWarranty = e => {
        this.setState({
            checked: e.target.checked,
        });
    };

    toggleEditShow = () => {
        this.setState({
            showEdit: !this.state.showEdit
        })
    }

    editVendorDetails = (values) => {
        const id = this.props.match.params && this.props.match.params.id;
        this.props.updateVendor(id, values);
    }

    handleActivitySearch = createDebounce(key => {
        if (key && key.length > 2)
            this.props.fetchActivitySno(key)
    }, 800);

    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            data,
            loading,
            filters,
            title,
            resource,
            form,
            tpw,
            quotations,
            subDocumentFilters,
            activities
        } = this.props;
        const vendorOptions = this.getVendorOptions();
        const components = {
            body: {
                row: EditableFormRow, cell: EditableCell,
            },
        };

        const columnsForSpares = [{
            title: 'Spares', dataIndex: 'spare', key: 'spare',
        }, {
            title: 'No. Of Units', dataIndex: 'spareUnits', key: 'spareUnits', width: '15%',
        },];

        if (title === 'EDIT') {
            if (data && data['spareCostData'] && data['spareCostData'].length) {
                if (data['spareCostData'][0]['jobCards'] && Object.keys(data['spareCostData'][0]['jobCards']).length) {
                    Object.keys(data['spareCostData'][0]['jobCards']).map((jobCard, index) => {
                        if (jobCard !== 'sno') {
                            columnsForSpares.push({
                                title: jobCard,
                                dataIndex: jobCard,
                                key: `${index}${jobCard}`,
                                editable: true,
                                width: '15%',
                            });
                        }
                    });
                }
            }
        } else {
            this.props && this.props.tableData && this.props.tableData.jobCards && this.props.tableData.jobCards.length && this.props.tableData.jobCards.map(jobCard => {
                if (jobCard !== 'sno') {
                    columnsForSpares.push({
                        title: jobCard, dataIndex: jobCard, key: jobCard, editable: true, width: '15%',
                    });
                }
            });
        }

        columnsForSpares.push({
            title: 'Total Units', dataIndex: 'total', key: 'total', width: '15%',
        });

        const columns = columnsForSpares && columnsForSpares.length && columnsForSpares.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col, onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    width: '15%',
                    handleSave: this.handleSave,
                    formTitle: title,
                }),
            };
        });

        const columnsForLabours = [{
            title: 'Labours', dataIndex: 'labour', key: 'labour',
        }, {
            title: 'Amount', dataIndex: 'labourCost', key: 'labourCost', width: '15%',
        },
        ];

        if (title === 'EDIT') {
            if (data && data['labourCostData'] && data['labourCostData'].length) {
                if (data['labourCostData'][0]['activities'] && Object.keys(data['labourCostData'][0]['activities']).length) {
                    Object.keys(data['labourCostData'][0]['activities']).map((act, index) => {
                        if (act !== 'sno') {
                            columnsForLabours.push({
                                title: act, dataIndex: act, key: `${index}${act}`, editable: true, width: '15%',
                            });
                        }
                    });
                }
            }
        } else {
            this.props && this.props.tableData && this.props.tableData.activities && this.props.tableData.activities.length && this.props.tableData.activities.map(act => {
                if (act !== 'sno') {
                    columnsForLabours.push({
                        title: act, dataIndex: act, key: act, editable: true, width: '15%',
                    });
                }
            });
        }

        columnsForLabours.push({
            title: 'Total Amount', dataIndex: 'total', key: 'total', width: '15%',
        });

        columnsForLabours.push({
            title: 'Equally',
            dataIndex: 'equal',
            key: 'equal',
            width: '15%',
            editable: true,
        });

        const labourColumns = columnsForLabours && columnsForLabours.length && columnsForLabours.map(col => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col, onCell: record => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleLabourSave,
                    formTitle: title,
                }),
            };
        });

        const tpwStyle = {
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between'
        }

        for (let i = 0; i < (data['spareCostData'] && data['spareCostData'].length); i++) {
            let jobCardData = [];
            jobCardData = data['spareCostData'][i]['jobCards'] && Object.keys(data['spareCostData'][i]['jobCards']);
            for (let j = 0; j < (jobCardData && jobCardData.length); j++) {
                data['spareCostData'][i][jobCardData[j]] = data['spareCostData'][i]['jobCards'][jobCardData[j]];
            }
        }

        for (let i = 0; i < (data['labourCostData'] && data['labourCostData'].length); i++) {
            let activityData = [];
            activityData = data['labourCostData'][i]['activities'] && Object.keys(data['labourCostData'][i]['activities']);
            for (let j = 0; j < (activityData && activityData.length); j++) {
                data['labourCostData'][i][activityData[j]] = data['labourCostData'][i]['activities'][activityData[j]];
            }
        }

        // console.log('filters', filters);

        return (<div style={{ width: '100%' }}>
            {title === 'CREATE' ?
                <Modal width={1500}
                    style={{ top: 15 }}
                    title={`Cost Allocation`}
                    onOk={this.handleOk}
                    onCancel={this.handleModalCancel}
                    visible={this.state.visible}
                    destroyOnClose={true}
                    footer={[<Button key="back" onClick={this.handleModalCancel}>
                        Cancel
                    </Button>, this.state.isModalValidated ?
                        <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
                            Submit
                        </Button> : '',]}
                > {(this.props && this.props.tableData && this.props.tableData.display === 'both') || (this.props.tableData && this.props.tableData.display === 'spare') ?
                    <Table
                        components={components}
                        style={{ overflowX: 'auto' }}
                        rowClassName={() => 'editable-row'}
                        bordered
                        columns={columns}
                        dataSource={title === 'EDIT' ? data && data['spareData'] : this.state.spareData}
                        pagination={false}
                    /> : ''}
                    {(this.props && this.props.tableData && this.props.tableData.display === 'both') || (this.props.tableData && this.props.tableData.display === 'labour') ?
                        <Table
                            components={components}
                            style={{ overflowX: 'auto' }}
                            rowClassName={() => 'editable-row'}
                            bordered
                            columns={labourColumns}
                            dataSource={this.state.labourData}
                            pagination={false}
                        /> : ''}

                    {(this.props && this.props.tableData && this.props.tableData.display === 'notFound' && this.props.tableData.display !== 'labour') ?
                        <div style={{ color: "red", fontSize: "18px" }}>
                            No Job Card Found, Please Submit to Continue </div> : ''}

                    {(this.props && this.props.tableData && this.props.tableData.display !== 'notFound' && this.props.tableData.display !== 'noScreen' && this.props.tableData.display === 'labour') ?
                        <div style={{ color: "red", fontSize: "18px" }}>
                            Spares Units Distribution is not allowed for Single Job Card </div> : ''}

                    {(this.props && this.props.tableData && this.props.tableData.display !== 'notFound' && this.props.tableData.display === 'noScreen' && this.props.tableData.display !== 'labour') ?
                        <div style={{ color: "red", fontSize: "18px" }}>
                            Labour Cost Distribution is not allowed for Single Job Card having single Activity, Please
                            Submit to
                            Continue </div> : ''}

                    {!this.state.isModalValidated ?
                        <div style={{ color: "red", fontSize: "18px" }}>{this.state.message}</div> : ''}

                </Modal> : <Modal width={1500}
                    style={{ top: 15 }}
                    title={`Cost Allocation`}
                    visible={this.state.visible}
                    footer={false}
                    onCancel={this.handleModalCancel}
                ><Table components={components}
                    style={{ overflowX: 'auto' }}
                    rowClassName={() => 'editable-row'}
                    bordered
                    columns={columns}
                    dataSource={data && data['spareCostData']}
                    pagination={false}
                    />
                    <Table components={components}
                        style={{ overflowX: 'auto' }}
                        rowClassName={() => 'editable-row'}
                        bordered
                        columns={labourColumns}
                        dataSource={data && data['labourCostData']}
                        pagination={false}
                    />
                </Modal>}
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
                    <Form onSubmit={this.handleSubmit} layout="vertical">
                        {title === 'EDIT' ? <Form.Item key={'invoiceNo'} label={'Invoice No'}>
                            {getFieldDecorator('invoiceNo', {
                                // rules: [{
                                //   required: filters && filters['invoiceNo'] && filters['invoiceNo'].options &&
                                //   filters['invoiceNo'].options.required ? filters['invoiceNo'].options.required : '',
                                //   message: `Invoice No is required!`
                                // }],
                                initialValue: data && data['invoiceNo'],
                            })(<Select disabled={true} />)}
                        </Form.Item> : ''}
                        <Form.Item key={'invoiceFor'} label={'Invoice For : '}>
                            {getFieldDecorator('invoiceFor', {
                                rules: [{
                                    required: filters && filters['invoiceFor'] && filters['invoiceFor'].options && filters['invoiceFor'].options.required ? filters['invoiceFor'].options.required : '',
                                    message: `Invoice For is required!`
                                }], initialValue: data && data['invoiceFor'],
                            })(<Radio.Group disabled={title === 'EDIT' && true} onChange={this.onRadioChange}
                                style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <Radio value={'tpwNo'}> Tpw No.</Radio>
                                <Radio value={'activityNo'}> Activity No.</Radio>
                            </Radio.Group>)}
                        </Form.Item>
                        {(this.state.value && this.state.value === 'tpwNo') || (data && data['invoiceFor'] === 'tpwNo') ?
                            <Form.Item key={'tpwSearchQuery'} label={'Search Tpw'}>
                                {getFieldDecorator('tpwNo', {
                                    rules: [{
                                        required: filters && filters['tpwNo'] && filters['tpwNo'].options && filters['tpwNo'].options.required ? filters['tpwNo'].options.required : '',
                                        message: `tpw No is required!`
                                    }], initialValue: (data && data.tpwNo) ? data.tpwNo : [],
                                })(<AutoComplete
                                    showSearch={true}
                                    placeholder={'ex. tpw'}
                                    onSearch={this.props.fetchTpwNo}
                                    onSelect={this.props.fetchQuotations}
                                    disabled={title !== 'EDIT'}>
                                    {tpw && tpw.data && tpw.data.map((item) => {
                                        return <Select.Option key={item._id}
                                            value={item['tpwNo']}>{item['tpwNo']}</Select.Option>
                                    })}
                                </AutoComplete>)}
                            </Form.Item> : (this.state.value && this.state.value === 'activityNo') || (data && data['invoiceFor'] === 'activityNo') ?
                                <SelectActivity data={data} activities={title === 'CREATE' ? activities : null}
                                    handleActivitySearch={this.handleActivitySearch}
                                    getFieldDecorator={getFieldDecorator} title={title} /> : ''}
                        <Form.Item key={'warranty'}>
                            <Checkbox
                                style={{ marginTop: "5px", marginBottom: "10px" }}
                                checked={title === 'EDIT' ? data && data['warranty'] : this.state.checked}
                                onChange={this.onChangeForWarranty}
                                disabled={title === 'EDIT'}
                            >
                                Under Warranty
                            </Checkbox>
                        </Form.Item>
                        {Object.keys(filters).map((item) => {
                            if (this.state.checked === false) {
                                if (filters[item].type === 'Array' && filters[item].schema && item !== 'spareCostData' && item !== 'labourCostData') {
                                    return <div
                                        key={filters[item] && filters[item].field ? filters[item].field : filters[item]}>
                                        {filters[item] && filters[item].field ? sanitizeFieldName(filters[item].field) : ''}
                                        <SubListTpw key={item} item={filters[item]} form={form}
                                            data={title === 'CREATE' ? (quotations && quotations[0] && quotations[0][item]) : data[item]}
                                            title={title} resource={resource}
                                            storeTotalData={this.props.storeTotalData}
                                            searchData={this.props.searchData} valueSelected={this.state.value}
                                            disableAll={title === 'EDIT'} />
                                    </div>
                                }
                            }
                        })}
                        <div key={'formItems'} style={tpwStyle}>
                            {Object.keys(filters).map((item) => {
                                if (item === 'totalCost') {
                                    let spareValue = [], labourValue = [], sumValue = 0, value = 0;
                                    if (this.state.value === 'activityNo' && this.props.changed) {
                                        spareValue = this.props && this.props.sparesData;
                                        labourValue = this.props && this.props.labourData;
                                        sumValue = 0;
                                        spareValue && spareValue.map(item => {
                                            sumValue = sumValue + item;
                                        });

                                        labourValue && labourValue.map(itm => {
                                            sumValue = sumValue + itm;
                                        });
                                        return <div key={'totalCost'} style={{ width: '48%' }}>
                                            <Form.Item key={'totalCost'}
                                                label='Total Invoice Amount'>
                                                {/*{getFieldDecorator('totalCost', {*/}
                                                {/*  rules: [{*/}
                                                {/*    required: filters['totalCost'].required,*/}
                                                {/*    message: ` Total Cost is required!`*/}
                                                {/*  }],*/}
                                                {/*  initialValue: sumValue || 0,*/}
                                                {/*})(<Input type='number'*/}
                                                {/*          disabled={true}/>)*/}
                                                {/*}*/}
                                                <Input type="number"
                                                    value={sumValue || 0}
                                                    disabled={true} />
                                            </Form.Item>
                                        </div>;
                                    } else if (this.state.value === 'tpwNo' && this.props.totalData) {
                                        return <div key={'totalCost'} style={{ width: '48%' }}>
                                            <Form.Item key={'totalCost'}
                                                label='Total Invoice Amount'>
                                                {getFieldDecorator('totalCost', {
                                                    rules: [{
                                                        required: filters['totalCost'].required,
                                                        message: ` Total Amount is required!`
                                                    }], initialValue: this.props.totalData || 0,
                                                })(<Input type='number'
                                                    disabled={true} />)}
                                            </Form.Item>
                                        </div>
                                    } else {
                                        return <div key={'totalCost'} style={{ width: '48%' }}>
                                            <Form.Item key={'totalCost'}
                                                label='Total Invoice Amount'>
                                                {getFieldDecorator('totalCost', {
                                                    rules: [{
                                                        required: filters['totalCost'].required,
                                                        message: ` Total Amount is required!`
                                                    }],
                                                    initialValue: (data && data['totalCost']) ? (data['totalCost']).toFixed(2) : quotations && quotations[0] && quotations[0]['totalCost'] || 0,
                                                })(<Input type='number'
                                                    disabled={true} />)}
                                            </Form.Item>
                                        </div>
                                    }
                                }
                                if (item === 'vendor') {
                                    const vendorData = (quotations && quotations[0]) ? quotations[0] : data;
                                    return <div key={'vendor'} style={{ width: '48%' }}>
                                        <Form.Item key={'vendor'}
                                                   label={sanitizeFieldName(filters['vendor'] && filters['vendor'].options && filters['vendor'].options.label ? filters['vendor'].options.label : 'vendor')}>
                                            {getFieldDecorator('vendor', {
                                                rules: [{
                                                    required: filters['vendor'] && filters['vendor'].required,
                                                    message: `${sanitizeFieldName(filters['vendor'] && filters['vendor'].options && filters['vendor'].options.label ? filters['vendor'].options.label : 'vendor')} is required!`
                                                }],
                                                initialValue: vendorData && vendorData['vendor'] && vendorData['vendor']._id,
                                            })(<Select
                                                showArrow={false}
                                                showSearch
                                                allowClear
                                                mode="single"
                                                disabled={(title === 'EDIT' && filters['vendor'] && filters['vendor'].options && filters['vendor'].options.disabledOnEdit) || false}
                                                style={{ width: '80%', marginTop: '-10px' }}
                                                filterOption={(input, option) =>
                                                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                                }
                                                placeholder={`Please Select ${sanitizeFieldName(filters['vendor'] && filters['vendor'].options && filters['vendor'].options.label ? filters['vendor'].options.label : 'vendor')}`}
                                            >
                                                {(vendorOptions || []).map((option) => (
                                                    <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>
                                                ))}
                                            </Select>)}
                                            {filters['vendor'] && filters['vendor'].options && filters['vendor'].options.master ?
                                                <InlineCreateMasterModal
                                                    item={filters['vendor'].options.ref}
                                                    onCreated={this.handleVendorCreated}
                                                    triggerStyle={{
                                                        margin: '0',
                                                        marginTop: '0',
                                                        marginLeft: '10px',
                                                        width: 'calc(100% - 10px)'
                                                    }}
                                                /> : ''}
                                        </Form.Item>
                                    </div>;
                                }
                                if (item === 'vendorInvoiceNumber') {
                                    return getFormFieldByTypeForTpwModule(filters, item, getFieldDecorator, (quotations && quotations[0]) ? quotations[0] : data, {
                                        resource, title, checked: this.state.checked, warranty: data && data['warranty']
                                    });
                                }
                                if (item === 'date' || item === 'targetDateOfCompletion') {
                                    if (item === 'date' && (this.state.checked || data && data['warranty'])) {
                                        return <div>
                                            {' '}
                                        </div>
                                    }
                                    return getFormFieldByTypeForTpwModule(filters, item, getFieldDecorator, (quotations && quotations[0]) ? quotations[0] : data, {
                                        resource, title, checked: this.state.checked, warranty: data && data['warranty']
                                    })
                                }
                                if (item === 'documents' && filters[item].type === 'Array' && filters[item].options.ref && item !== 'spareCostData' && item !== 'labourCostData') {
                                    return <DocumentList match={this.props.match} history={this.props.history}
                                        key={item} item={filters[item]} form={form}
                                        data={title === 'CREATE' ? (quotations && quotations[0] && quotations[0][item]) : data[item]}
                                        subDocumentFilters={subDocumentFilters} resource={resource}
                                        title={title}
                                        hideRemove={title && title === 'EDIT'} hideEdit={false}
                                        getDocumentData={this.getDocumentData} />
                                }
                            })}
                        </div>
                        {title === 'EDIT' ? <div>
                            <Button style={{
                                backgroundColor: 'lightGray', borderRadius: '8px', color: 'black', marginTop: '15px',
                            }} onClick={this.viewCostAllocation}> View Cost Allocation </Button>
                            {/*<Button style={{marginTop: '15px',}} type={'button'} onClick={() => this.toggleEditShow()}>Edit*/}
                            {/*Data</Button>*/}
                        </div> : ''}
                        {title === 'CREATE' ? <Form.Item>
                            <Button type="primary" className="gx-mb-0" htmlType="submit"
                                loading={loading}>CREATE</Button>
                        </Form.Item> : ''}
                        {
                            title === 'EDIT' ?
                                <Form.Item>
                                    <Button type="primary" className="gx-mb-0" htmlType="submit"
                                        loading={loading}>UPDATE</Button>
                                </Form.Item> : ''
                        }
                    </Form>
                </Card>
            </Spin>
            {/*{*/}
            {/*title === 'EDIT' ?*/}
            {/*<VendorDetails options={{vendors: filters['vendor'], date: filters['date']}}*/}
            {/*getFieldDecorator={getFieldDecorator} toggleShow={this.toggleEditShow}*/}
            {/*isShow={this.state.showEdit} onSubmit={this.editVendorDetails}*/}
            {/*k={'documents'} item={filters['documents']}*/}
            {/*data={title === 'CREATE' ? (quotations && quotations[0] && quotations[0]['documents']) : data['documents']}*/}
            {/*subDocumentFilters={subDocumentFilters} resource={resource} title={title}*/}
            {/*getDocumentData={this.getDocumentData}*/}
            {/*form={this.props.form}/> : ''*/}
            {/*}*/}

        </div>);
    }
}

const CreateForm = Form.create({
    name: 'global_state', onFieldsChange(props, changedFields) {
    },
})(Create);

export default CreateForm;
